/* eslint-disable react/prop-types */
import React, { memo, useCallback, useState } from "react";
import { get, includes, map, size, toLower } from "lodash";
import { Select, Spin } from "antd";
import services from "services";
import styled from "styled-components";
import { removeVietnameseTones } from "lib/admin";

const DEFAULT_SELECT_STYLES = {
  width: "100%"
};

const toOptions = (dataSource, valueKey, labelKey, disabledList) => {
  return map(dataSource, data => ({
    label: data[labelKey],
    value: data[valueKey],
    disabled:
      disabledList && size(disabledList) > 0
        ? includes(disabledList, data[valueKey])
        : false
  }));
};
const defaultFilterOption = (input, option) =>
  option && toLower(removeVietnameseTones(get(option, "label", ""))).indexOf(toLower(removeVietnameseTones(input))) >= 0;
let timer = null;
const AppBaseSelect = ({
  defaultValue,
  onChange,
  onSelect,
  isDisable,
  dataSource,
  allowConvert,
  valueKey = "id",
  labelKey = "name",
  showSearch = true,
  allowRemoteSearch,
  filterOption = defaultFilterOption,
  disabledList,
  innerRef,
  ...restProps
}) => {
  const [remoteDataSource, setRemoteDataSource] = useState([]);
  const [filterOptionMode, setFilterOptionMode] = useState(false);
  const [fetching, setFetching] = useState(false);
  let options = [];
  if (allowConvert && !allowRemoteSearch) {
    // console.log("start toOptions", performance.now())
    options = toOptions(dataSource, valueKey, labelKey, disabledList || []);
    // console.log("end toOptions", performance.now())
  } else {
    options = dataSource;
  }
  const _handleSetFilterOptionModeWhenSearching = useCallback(search => {
    if (size(search) < 3) {
      setFilterOptionMode(defaultFilterOption);
      return false;
    } else {
      setFilterOptionMode(false);
      return true;
    }
  }, []);
  const _handleGetListUser = useCallback(async search => {
    setFetching(true);
    setRemoteDataSource([]);
    const response = await services.WorkService.fetchAutocompleteUser(
      search,
      1,
      100
    );
    if (response && response.data) {
      let data = toOptions(response.data.data, valueKey, labelKey);
      setRemoteDataSource(data);
    }
    setFetching(false);
  }, []);
  const _handleSearch = useCallback(
    search => {
      // Set filter mode
      let filterMode = _handleSetFilterOptionModeWhenSearching(search);
      if (filterMode) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          _handleGetListUser(search);
        }, 800);
      }
    },
    [_handleSetFilterOptionModeWhenSearching, _handleGetListUser]
  );
  // console.log("render select")
  return (
    <Select
      {...restProps}
      allowClear
      
      defaultValue={defaultValue}
      disabled={isDisable}
      filterOption={filterOption ? filterOption : filterOptionMode}
      loading={fetching}
      notFoundContent={fetching ? <Spin size="small" /> : "Không có dữ liệu"}
      options={allowRemoteSearch ? remoteDataSource : options}
      ref={innerRef}
      showSearch={showSearch}
      onChange={onChange}
      onSearch={allowRemoteSearch ? _handleSearch : null}
      onSelect={onSelect}
    />
  );
};
// eslint-disable-next-line react/display-name
const StyledAppBaseSelect = styled(
  React.forwardRef((props, ref) => <AppBaseSelect {...props} innerRef={ref} />)
)`
  width: 100%;
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
`;
export default StyledAppBaseSelect;
